/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verified_EntityInputs */

const en_verified_entity = /** @type {(inputs: Verified_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Entity`)
};

const es_verified_entity = /** @type {(inputs: Verified_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entidad Verificada`)
};

const fr_verified_entity = /** @type {(inputs: Verified_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entité vérifiée`)
};

const de_verified_entity = /** @type {(inputs: Verified_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifizierte Entität`)
};

const id_verified_entity = /** @type {(inputs: Verified_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitas Terverifikasi`)
};

/** @type {(inputs: Verified_EntityInputs) => LocalizedString} */
const ja_verified_entity = en_verified_entity;

/** @type {(inputs: Verified_EntityInputs) => LocalizedString} */
const zh_verified_entity = en_verified_entity;

/** @type {(inputs: Verified_EntityInputs) => LocalizedString} */
const ar_verified_entity = en_verified_entity;

/** @type {(inputs: Verified_EntityInputs) => LocalizedString} */
const it_verified_entity = en_verified_entity;

/** @type {(inputs: Verified_EntityInputs) => LocalizedString} */
const ru_verified_entity = en_verified_entity;

/** @type {(inputs: Verified_EntityInputs) => LocalizedString} */
const pt_verified_entity = en_verified_entity;

/** @type {(inputs: Verified_EntityInputs) => LocalizedString} */
const ko_verified_entity = en_verified_entity;

/**
* | output |
* | --- |
* | "Verified Entity" |
*
* @param {Verified_EntityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verified_entity = /** @type {((inputs?: Verified_EntityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verified_EntityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verified_entity(inputs)
	if (locale === "es") return es_verified_entity(inputs)
	if (locale === "fr") return fr_verified_entity(inputs)
	if (locale === "de") return de_verified_entity(inputs)
	if (locale === "ja") return ja_verified_entity(inputs)
	if (locale === "zh") return zh_verified_entity(inputs)
	if (locale === "ar") return ar_verified_entity(inputs)
	if (locale === "id") return id_verified_entity(inputs)
	if (locale === "it") return it_verified_entity(inputs)
	if (locale === "ru") return ru_verified_entity(inputs)
	if (locale === "pt") return pt_verified_entity(inputs)
	return ko_verified_entity(inputs)
});